export default __webpack_public_path__ + "static/media/lojamidhaz.43b513e3.svg";